import { modifier } from 'ember-modifier';
export default modifier(function onResize(element, positional) {
  const callback = positional[0];
  const observer = new ResizeObserver(() => callback(element));
  observer.observe(element);
  return () => observer.disconnect();
});